import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as API from 'api/baseAPI';
import { setGlobalLoading } from 'redux/appSlice';
import EmbedV1 from './v1/embed';
import EmbedV2 from './v2/embed';
import NotFound from 'components/notFound';

export default function Embed(props) {
  const dispatch = useDispatch();
  const params = useParams();
  const [version, setVersion] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!params.eventId) {
      return;
    }
    dispatch(setGlobalLoading(true));

    API.getEvent(params.eventId)
      .then((response) => {
        if (response && response.data) {
          if (typeof response.data !== 'object') {
            throw new Error('Invalid Event');
          }
          if (response.data.version) {
            setVersion(response.data.version);
          } else {
            setVersion('v1');
          }
        } else {
          throw new Error('Invalid Event');
        }
      })
      .catch(() => {
        setNotFound(true);
        dispatch(setGlobalLoading(false));
      });
  }, [dispatch, params.eventId]);

  return (
    <Fragment>
      {notFound ? (
        <NotFound />
      ) : (
        <Fragment>
          {version === 'v1' && <EmbedV1 {...props} />}
          {version === 'v2' && <EmbedV2 {...props} />}
        </Fragment>
      )}
    </Fragment>
  );
}
